import React from "react";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";
import MyUserDetails from "./components/MyUserDetails";

// Export all My User components
export { default as MyUserDetails } from "./components/MyUserDetails";
export { default as QuestionSection } from "./components/QuestionSection";
export { default as FileUpload } from "./components/FileUpload";

// Export hooks
export { useMyUserForm } from "./hooks/useMyUserForm";
export { useUserNameFetch } from "./hooks/useUserNameFetch";
export { useFileUpload } from "./hooks/useFileUpload";
export { useFormValidation } from "./hooks/useFormValidation";

// Export services
export * from "./services/myUserService";

/**
 * MyUserPage - Page wrapper
 * Renders PageLayout + MyUserDetails
 */
export const MyUserPage = () => {
  usePageInitialization();
  return (
    <PageLayout title="My User" backPath="/">
      <MyUserDetails />
    </PageLayout>
  );
};
